import type {
  DirectoryUser,
  PersonDetailsDto,
  PublicUser,
  RegisterOfficerRequest,
  RegisterOfficerResponse,
  RegistrationSummary,
  UpdateProfileRequest,
} from '@cosvision/shared';
import { request } from '../api.js';

export function updateMyProfile(patch: UpdateProfileRequest): Promise<PublicUser> {
  return request<PublicUser>('patch', '/auth/me', patch);
}

/** Public officer self-registration. The account is created PENDING approval. */
export function registerOfficer(body: RegisterOfficerRequest): Promise<RegisterOfficerResponse> {
  return request<RegisterOfficerResponse>('post', '/auth/register', body);
}

/** CO-only: officers awaiting approval. */
export function listRegistrations(): Promise<RegistrationSummary[]> {
  return request<RegistrationSummary[]>('get', '/auth/registrations');
}

export function approveRegistration(id: string): Promise<RegistrationSummary> {
  return request<RegistrationSummary>('post', `/auth/registrations/${id}/approve`);
}

export function rejectRegistration(id: string, reason?: string): Promise<RegistrationSummary> {
  return request<RegistrationSummary>('post', `/auth/registrations/${id}/reject`, { reason });
}

/** People directory — the CO + active officers (operators excluded server-side). */
export function listPeople(): Promise<DirectoryUser[]> {
  return request<DirectoryUser[]>('get', '/people');
}

/** Rich per-person view for the People page: identity + workload + boards. */
export function listPeopleDetails(): Promise<PersonDetailsDto[]> {
  return request<PersonDetailsDto[]>('get', '/people/details');
}
